import { Flex } from "antd";
import { FC } from "react";
import { Market, TaskUpdateMarketInfo } from "tm-shared/types";

import { SubtaskCard } from "@/components/TasksModals/components/SubtaskCard";

import { CustomTaskFromTaskButton } from "../components/CustomTaskFromTaskButton";
import { TaskViewModal } from "../TaskViewModal";

interface UpdateMarketInfoViewModalProps {
    task: TaskUpdateMarketInfo;
    market: Market;
    onClose: () => void;
}

export const UpdateMarketInfoViewModal: FC<UpdateMarketInfoViewModalProps> = ({
    market,
    task,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const subtasks = task.context.subtasks;
    const taskImages = Object.values(taskPayload).flatMap(
        ({ photos }) => photos,
    );

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    market={market}
                    images={taskImages}
                />
                {subtasks.map(({ subtaskId, name }) => {
                    const subtaskPayload = taskPayload[subtaskId];

                    if (!subtaskPayload) return null;

                    return (
                        <SubtaskCard
                            key={subtaskId}
                            subtask={subtaskPayload}
                            title={name}
                        />
                    );
                })}
            </Flex>
        </TaskViewModal>
    );
};
